"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OktonAuthPage = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const lu_1 = require("react-icons/lu");
const useOktonTheme_1 = require("../../theme/useOktonTheme");
const brand_1 = require("./brand");
const OktonAuthPage = ({ title, children, footer, onSubmit, maxWidth = 488, }) => {
    const { theme, toggleTheme } = (0, useOktonTheme_1.useOktonTheme)();
    const dark = theme === "dark";
    const pageBg = (0, react_1.useColorModeValue)("blue.600", "gray.800");
    const cardBg = (0, react_1.useColorModeValue)("white", "gray.700");
    const textColor = (0, react_1.useColorModeValue)("gray.700", "white");
    return (react_2.default.createElement(react_1.Flex, { w: "100vw", minH: "100vh", flexDir: "column", align: "center", justify: "center", bg: pageBg, px: "4", py: "8" },
        react_2.default.createElement(react_1.Image, { src: brand_1.oktonLogoWhite, alt: "Okton - Sistemas Empresariais", mb: "8", w: "250px", maxH: "80px", objectFit: "contain" }),
        react_2.default.createElement(react_1.Flex, { as: onSubmit ? "form" : "div", onSubmit: onSubmit, width: "100%", maxWidth: maxWidth, flexDir: "column", p: { base: "6", sm: "8" }, rounded: "2xl", boxShadow: "xs", bg: cardBg },
            react_2.default.createElement(react_1.Flex, { display: "grid", gridTemplateColumns: "22px 1fr 22px", align: "center", mb: "4" },
                react_2.default.createElement(react_1.Box, null),
                react_2.default.createElement(react_1.Text, { color: textColor, fontSize: "sm", fontWeight: "medium", textAlign: "center" }, title),
                react_2.default.createElement(react_1.Icon, { as: (dark ? lu_1.LuMoon : lu_1.LuSun), color: dark ? "white" : "blue.500", fontSize: "22", cursor: "pointer", onClick: toggleTheme })),
            children,
            footer ? (react_2.default.createElement(react_2.default.Fragment, null,
                react_2.default.createElement(react_1.Divider, { my: "6", borderColor: dark ? "gray.500" : "gray.300" }),
                footer)) : null)));
};
exports.OktonAuthPage = OktonAuthPage;
//# sourceMappingURL=OktonAuthPage.js.map